@if (!displayGameName()) {
  <div #mask>
    <div class="img-wrapper">
      <img
        src="assets/app-branding/img/CouncilLogo.png"
        alt="{{i18n.str('challengeu.welcome_logo_alt', 'The logo of the Council of the EU')()}}"
        title="{{i18n.str('challengeu.welcome_logo_alt', 'The logo of the Council of the EU')()}}"
        >
      </div>
      <div class="divider-wrapper">
        <span></span>
      </div>
      <div class="text-wrapper">
        <h2 class="jeopary-welcome-msg">
          {{i18n.str('challengeu.welcome_council_title', 'The Council of the European Union')()}}
          <br>
            {{i18n.str('challengeu.welcome_proudly_presents', 'proudly presents')()}}
          </h2>
        </div>
      </div>
    }

    @if (displayGameName()) {
      <div style="width: 100%;">
        <h1 #gamename class="game-name fly-in">
          <span #gnLetter>C</span>
          <span #gnLetter class="flicker-fast">H</span>
          <span #gnLetter>A</span>
          <span #gnLetter>L</span>
          <span #gnLetter>L</span>
          <span #gnLetter>E</span>
          <span #gnLetter>N</span>
          <span #gnLetter>G</span>
          <span #gnLetter class="logo-eu-bigger">E</span>
          <span #gnLetter class="logo-eu-bigger">U</span>
          <span #gnLetter class="flicker-slow">!</span>
        </h1>
        <h2 [class.disabled]="!showStartBtn()" class="jeopardy-primary-button glow fly-in">
          <a href="#" class="neon" (click)="startGame($event)">
            {{i18n.str('challengeu.welcome_play', 'PLAY')()}}
          </a>
        </h2>
      </div>
    }
